<template>
  <div class="mt-2 px-2 white--text">
    <v-btn block color="primary" @click="openMainDialog()">
      <v-icon class="mr-2">mdi-book-open-outline</v-icon>
      Labels
    </v-btn>

    <v-dialog v-model="showMainDialog" max-width="250px" transition="dialog-bottom-transition" persistent>
      <v-card flat color="cardbackground" class="ma-4">
        <v-card-text class="pa-4">
          <egg-dialog-title title="Label Picker" @close-clicked="closeMainDialog()" />
          <div v-for="(labelType, index) in labelTypes" :key="index">
            <v-card class="ma-2 pa-2" flat>
              <v-img contain height="120px" width="155px" :src="labelType" class="ma-2">
              </v-img>
              <v-card-actions style="justify-content: center;">
                <v-btn class="ma-2" color="primary" @click.stop="saveItem(index)">
                  Select
                </v-btn>
              </v-card-actions>
            </v-card>
            <v-divider />
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import DialogTitle from './DialogTitle'
import LabelManager from '../utils/LabelManager'
import { mapState, mapActions } from 'vuex'

export default {
  props: {
    disabled: {
      type: Boolean,
      default: true
    },
  },
  created() {
    this.rules = { ...this.$root.validationRules };
  },
  components: {
    'egg-dialog-title': DialogTitle
  },
  data() {
    return {
      labelTypes: [],
      editedItem: {},
      itemToDelete: {},
      isAdd: false,
      rules: null,
      search: '',
      showDeleteDialog: false,
      showChangeDialog: false,
      showMainDialog: false,
      validForm: true
    }
  },
  computed: {
    ...mapState(['settings', 'isOnline'])
  },
  methods: {
    ...mapActions(['updateSettingsInStore']),
    closeMainDialog() {
      this.$emit('close-label-select-dialog');
      this.showMainDialog = false;

    },
    async openMainDialog() {
      const labelManager = new LabelManager();
      this.labelTypes = await labelManager.generateLabelSamples();
      this.showMainDialog = true;
    },
    async saveItem(index) {
      const settings = { ...this.settings };
      settings.label = index;
      this.updateSettingsInStore(settings);
      this.closeMainDialog();
    }
  }
}
</script>